import { useContext } from "react";
import { withUbdAnalyticsStep } from "@aspirasi/react-data-analytics";
import { StoreContext } from "../../../store/context";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";

import { useThemeStyles } from "../../../styles/themes";
import "./MandatePending.scss";

const MandatePending = () => {
  const classes = useThemeStyles();
  const { state, actions } = useContext(StoreContext);

  return (
    state.prerequisites && (
      <>
        <Header />
        <div className="page page-mandate-pending">
          <div className={`${classes.content} ${classes.customScrollbar} content custom-scrollbar`}>

            <div className="body-holder">
              <div className="banner-holder">
                <img className="banner" src="/images/journey-disconnected@2x.png" alt="success" />
              </div>

              <p className="text-title">
                In Progress...
              </p>

              <p className="text-desc">
                Your application is being processed. Please check back in 30 minutes.
                <br />
                <br />
                If processing takes longer than expected, please contact <a className="contact-link" href={`mailto:${process.env.REACT_APP_SUPPORT_EMAIL}`}>{process.env.REACT_APP_SUPPORT_EMAIL}</a> for assistance.
                <br />
                <br />
                If you'd like to return to the Boost homepage, click (x).
              </p>
            </div>
          </div>
          <Footer />
        </div>
      </>
    )
  );
};

export default withUbdAnalyticsStep(MandatePending, {
  stepId: "MandatePending",
  endJourneyOnStepStart: true,
});
